import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { createContext, useContext } from "react";

export interface WindowContextModel {
    clientWidth?: number;
    clientHeight?: number;
    currentBreakpoint?: BreakpointKey;
}

export const WindowContext = createContext<WindowContextModel>({} as any);
export const useWindowContext = () => useContext(WindowContext);
